// Define transitions that indicate the 'approver' should be shown.
export const SHOW_APPROVER_TRANSITIONS: ReadonlyArray<[string, string]> = [
    ['1', 'B'], // Transition from 1 to B indicates improvement
    ['1', '3'], // Transition from 1 to 3 indicates improvement
    ['A', 'B'], // Transition from A to B indicates improvement
    ['A', '3'], // Transition from A to 3 indicates improvement
];

// Define transitions that are possible without 'approver'.
export const HIDE_APPROVER_TRANSITIONS: ReadonlyArray<[string, string]> = [
    ['1', 'A'], // Transition from 1 to A indicates improvement
    ['B', '3'], // Transition from B to 3 indicates improvement
    ['A', '1'], // Transition from A to 1 indicates worsening condition
    ['B', '1'], // Transition from B to 1 indicates worsening condition
    ['B', 'A'], // Transition from B to A indicates worsening condition
];

// Define transitions that indicate a 'warning' should be shown.
export const IMPOSSIBLE_TRANSITIONS: ReadonlyArray<[string, string]> = [
    ['3', 'A'], // Transition from 3 to A indicates worsening condition
    ['3', 'B'], // Transition from 3 to B indicates worsening condition
    ['3', '1'], // Transition from 3 to 1 indicates worsening condition
    ['3', '2'], // Transition from 3 to 2 indicates worsening condition
];
